import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export const learnMoreModal = {
  title: () => i18n.t(i18nKeys.redCardActivate__learnMoreModal__title),
  primaryAction: () =>
    i18n.t(i18nKeys.redCardActivate__learnMoreModal__primaryAction),
  bulletText1: () =>
    i18n.t(i18nKeys.redCardActivate__learnMoreModal__bulletText1),
  bulletText2: () =>
    i18n.t(i18nKeys.redCardActivate__learnMoreModal__bulletText2),
  bulletText3: () =>
    i18n.t(i18nKeys.redCardActivate__learnMoreModal__bulletText3),
  bulletText4: () =>
    i18n.t(i18nKeys.redCardActivate__learnMoreModal__bulletText4),
  bulletText5: () =>
    i18n.t(i18nKeys.redCardActivate__learnMoreModal__bulletText5),
}

export default {
  cardLastFour: () => i18n.t(i18nKeys.redCardActivate__cardLastFour),
  cardDelightNumber: () => i18n.t(i18nKeys.redCardActivate__cardDelightNumber),
  labelLastFour: () => i18n.t(i18nKeys.redCardActivate__labelLastFour),
  labelDelightNumber: () =>
    i18n.t(i18nKeys.redCardActivate__labelDelightNumber),
  activateButton: () => i18n.t(i18nKeys.redCardActivate__activateButton),
  title: () => i18n.t(i18nKeys.redCardActivate__title),
  idv2Title: () => i18n.t(i18nKeys.redCardActivate__idv2__title),
  description: () => i18n.t(i18nKeys.redCardActivate__description),
  learnMore: () => i18n.t(i18nKeys.redCardActivate__learnMore),
  idv2LearnMore: () => i18n.t(i18nKeys.redCardActivate__idv2__learnMore),
  goBack: () => i18n.t(i18nKeys.redCardActivate__goBack),
}
